import * as React from 'react';
import { DeprecatedEventWrapper } from '../../../../common/analyticsEvents/DeprecatedEventWrapper';
import { IReactTranslateService } from '../../../../common/react/IReactTranslateService';
import { imgPath } from '../../../../common/utilities/ImgUrl';

import { ContentActions } from '../../../../ts/services/ContentActions';
import { ServerService } from '../../../../ts/services/ServerService';


import { GuidePanel } from '../../components/GuidePanel';

export class ConnectDataPanel extends React.Component<ConnectDataPanel.Props, ConnectDataPanel.State> {

  constructor(props: ConnectDataPanel.Props) {
    super(props);
  }

  private static imageUrl = imgPath('getting_started_desktop.png');

  private openWorkbookFlow(ctaText: string, content: string) {
    // Deprecated, use TelemetryService instead of AnalyticsEvents.
    this.props.analyticsEvents.sendGettingStartedEvent('new_workbook_cta', ctaText, content);
    this.props.ContentActions.newEmptyWorkbook(this.props.ServerService.sessionSiteUrlName());
  }

  public render(): any {
    const content = this.props.translate('getttingStarted_dashboardIntroContent');
    const ctaText = this.props.translate('gettingStarted_downloadCTA_3');
    const callback = () => this.openWorkbookFlow(ctaText, content);

    return (
      <GuidePanel
        imgUrl={ ConnectDataPanel.imageUrl }
        content={ content }
        callToActionText={ ctaText }
        callback={ callback }
      />
    );
  }
}

export module ConnectDataPanel {
  export interface Props {
    translate: IReactTranslateService;
    ContentActions: ContentActions;
    analyticsEvents: DeprecatedEventWrapper;
    ServerService: ServerService;
  }

  export interface State {}
}
